import { render, staticRenderFns } from "./DocumentUploadLite.vue?vue&type=template&id=4ff25396&"
import script from "./DocumentUploadLite.vue?vue&type=script&lang=js&"
export * from "./DocumentUploadLite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports